module.exports = __webpack_public_path__ + "static/media/S (206).48209bee.jpg";